export default "My own take on a classic browser game.\n[curveball.mike-moe.com](https://curveball.mike-moe.com/)"